import React,{Component} from 'react'
import {LandingPage,MobileViewComponent,InfoItemView,DashbordCarousel,RequestDemo} from '../../components/mini_portal_components/mini-portal_components'
import MiniProtal from '../../components/mini_portal_components/mini_portal'
import List from '../../components/List'
import {infoList1,infoList2,communityWebViewData,communityMobileViewData,dashboardData,dashboardDataMobile} from '../../data/community-engagement'

const landingPageContent = {head:'Your community at your fingertips',para:'Hubler Connect delivers on its name. We help people connect, collaborate, engage and share within a community by providing all resources and communication enablers in one place.'}

const headerMobileView = {head:'Member Connect',para:'Be Inspired - Interact & Collaborate. Post photos, videos - Share special moments with your network. Bring camaraderie among members with various opportunities & topics for intriguing discussions. This makes the conversations genuine, relevant & brings back active & inactive members.'}

export default class Connect extends MiniProtal{
    render(){
        return <div className={'mini-protal-component'}>
            <LandingPage content={landingPageContent}/>
            <MobileViewComponent communityWebViewData ={communityWebViewData} communityMobileViewData={communityMobileViewData} headerData={headerMobileView}/>
            <div className={'first-list-view'}>
                <List listItem={InfoItemView} items={infoList1} className={'info-list-view'}/>
            </div>
            <DashbordCarousel dashboardData={dashboardData} dashboardDataMobile={dashboardDataMobile}/>
            <div className={'secand-list-view'}>
                <List listItem={InfoItemView} items={infoList2} className={'info-list-view'}/>
            </div>
            <RequestDemo/>
        </div>
    }
}


// WEBPACK FOOTER //
// ./src/pages/solutions/community-engagement.js